import React, { useState, useEffect } from 'react';

const modalStyles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' },
  content: { background: 'white', borderRadius: '16px', width: '100%', maxWidth: '900px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e2e8f0' },
  closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: '#94a3b8', cursor: 'pointer', padding: '4px', lineHeight: 1 },
  body: { flex: 1, overflowY: 'auto', padding: '20px' },
  subtitle: { margin: '0 0 20px', fontSize: '14px', color: '#64748b' },
  formGroup: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', fontSize: '14px', fontWeight: 500, color: '#334155' },
  input: { width: '100%', padding: '12px 14px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', boxSizing: 'border-box' },
  inputAutre: { width: '100%', padding: '10px 12px', border: '1px solid #93c5fd', borderRadius: '8px', fontSize: '14px', background: '#eff6ff', boxSizing: 'border-box', marginTop: '6px' },
  grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' },
  section: { padding: '16px', borderRadius: '12px', border: '2px solid' },
  sectionProtection: { background: '#fef3c7', borderColor: '#f59e0b' },
  sectionCanalisation: { background: '#dbeafe', borderColor: '#3b82f6' },
  sectionDDR: { background: '#dcfce7', borderColor: '#22c55e' },
  sectionTitle: { margin: '0 0 16px', fontSize: '15px', fontWeight: 700 },
  footer: { display: 'flex', gap: '12px', padding: '16px 20px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' },
  btnSecondary: { flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', background: 'white', border: '1px solid #d1d5db', color: '#374151' },
  btnPrimary: { flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', border: 'none', color: 'white' }
};

const EMPTY_DATA = {
  type: '',
  type_autre: '',
  calibre_reglage: '',
  calibre_reglage_autre: '',
  im_courbe: '',
  pdc: '',
  pdc_autre: '',
  section: '',
  nature: '',
  coef_global_iz: '',
  coef_global_iz_autre: '',
  idn: '',
  tempo: '',
  essai: '',
  isol: '',
  isol_autre: ''
};

// Reconstruit les champs "_autre" si la donnée stockée contient une valeur libre
// (par ex. lorsqu'on rouvre une saisie où le calibre était hors liste).
const PRESET_VALUES = {
  type: ['DD43', 'DD44', 'D21', 'D22', 'D43', 'D44', 'DD21', 'DD22'],
  calibre_reglage: ['40', '60', '80', '100'],
  pdc: ['6', '10', '15', '20'],
  coef_global_iz: ['0,7', '0,74', '0,8', '0,9'],
  isol: ['B', 'M', '<0,5', '>0,5']
};

const buildFromInitial = (initial) => {
  if (!initial) return { ...EMPTY_DATA };
  const merged = { ...EMPTY_DATA, ...initial };
  Object.entries(PRESET_VALUES).forEach(([field, presets]) => {
    const value = merged[field];
    if (value && !presets.includes(value)) {
      merged[`${field}_autre`] = value;
      merged[field] = 'Autre';
    }
  });
  return merged;
};

function DisjoncteurModalMobile({ isOpen, onClose, onSave, initialData }) {
  const [data, setData] = useState(() => buildFromInitial(initialData));

  useEffect(() => {
    if (isOpen) {
      setData(buildFromInitial(initialData));
    }
  }, [isOpen, initialData]);

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const isValid = !!data.type && !!data.calibre_reglage
    && (data.type !== 'Autre' || !!data.type_autre)
    && (data.calibre_reglage !== 'Autre' || !!data.calibre_reglage_autre);

  const handleSave = () => {
    if (!isValid) return;
    const finalData = {
      ...data,
      type: data.type === 'Autre' ? data.type_autre : data.type,
      calibre_reglage: data.calibre_reglage === 'Autre' ? data.calibre_reglage_autre : data.calibre_reglage,
      pdc: data.pdc === 'Autre' ? data.pdc_autre : data.pdc,
      coef_global_iz: data.coef_global_iz === 'Autre' ? data.coef_global_iz_autre : data.coef_global_iz,
      isol: data.isol === 'Autre' ? data.isol_autre : data.isol
    };
    onSave(finalData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.header}>
          <h2 style={{margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b'}}>⚡ Caractéristiques du Disjoncteur Général de Branchement</h2>
          <button style={modalStyles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={modalStyles.body}>
          <p style={modalStyles.subtitle}>Renseignez les caractéristiques du disjoncteur général.</p>

          <div style={modalStyles.grid3}>
            {/* COLONNE 1: PROTECTION */}
            <div style={{...modalStyles.section, ...modalStyles.sectionProtection}}>
              <h3 style={{...modalStyles.sectionTitle, color: '#92400e'}}>Protection</h3>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Type *</label>
                <select value={data.type} onChange={(e) => handleChange('type', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="DD43">DD43</option>
                  <option value="DD44">DD44</option>
                  <option value="D21">D21</option>
                  <option value="D22">D22</option>
                  <option value="D43">D43</option>
                  <option value="D44">D44</option>
                  <option value="DD21">DD21</option>
                  <option value="DD22">DD22</option>
                  <option value="Autre">Autre (saisie libre)</option>
                </select>
                {data.type === 'Autre' && (
                  <input type="text" value={data.type_autre} onChange={(e) => handleChange('type_autre', e.target.value)} style={modalStyles.inputAutre} placeholder="Précisez le type..." />
                )}
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Calibre ou réglage (A) *</label>
                <select value={data.calibre_reglage} onChange={(e) => handleChange('calibre_reglage', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="40">40 A</option>
                  <option value="60">60 A</option>
                  <option value="80">80 A</option>
                  <option value="100">100 A</option>
                  <option value="Autre">Autre (saisie libre)</option>
                </select>
                {data.calibre_reglage === 'Autre' && (
                  <input type="number" value={data.calibre_reglage_autre} onChange={(e) => handleChange('calibre_reglage_autre', e.target.value)} style={modalStyles.inputAutre} placeholder="Précisez le calibre..." />
                )}
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Im / Courbe</label>
                <input type="text" value={data.im_courbe} onChange={(e) => handleChange('im_courbe', e.target.value)} style={modalStyles.input} placeholder="Ex: C, D..." />
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Pdc (kA)</label>
                <select value={data.pdc} onChange={(e) => handleChange('pdc', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="6">6 kA</option>
                  <option value="10">10 kA</option>
                  <option value="15">15 kA</option>
                  <option value="20">20 kA</option>
                  <option value="Autre">Autre (saisie libre)</option>
                </select>
                {data.pdc === 'Autre' && (
                  <input type="number" value={data.pdc_autre} onChange={(e) => handleChange('pdc_autre', e.target.value)} style={modalStyles.inputAutre} placeholder="Précisez le Pdc..." />
                )}
              </div>
            </div>

            {/* COLONNE 2: CANALISATION */}
            <div style={{...modalStyles.section, ...modalStyles.sectionCanalisation}}>
              <h3 style={{...modalStyles.sectionTitle, color: '#1e40af'}}>Canalisation</h3>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Section</label>
                <input type="text" value={data.section} onChange={(e) => handleChange('section', e.target.value)} style={modalStyles.input} placeholder="Ex: 16 mm²" />
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Nature</label>
                <select value={data.nature} onChange={(e) => handleChange('nature', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="Cu">Cuivre (Cu)</option>
                  <option value="Al">Aluminium (Al)</option>
                </select>
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Coef global ou Iz (A)</label>
                <select value={data.coef_global_iz} onChange={(e) => handleChange('coef_global_iz', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="0,7">0,7</option>
                  <option value="0,74">0,74</option>
                  <option value="0,8">0,8</option>
                  <option value="0,9">0,9</option>
                  <option value="Autre">Autre (saisie libre)</option>
                </select>
                {data.coef_global_iz === 'Autre' && (
                  <input type="number" step="0.01" value={data.coef_global_iz_autre} onChange={(e) => handleChange('coef_global_iz_autre', e.target.value)} style={modalStyles.inputAutre} placeholder="Précisez le coefficient..." />
                )}
              </div>
            </div>

            {/* COLONNE 3: DDR */}
            <div style={{...modalStyles.section, ...modalStyles.sectionDDR}}>
              <h3 style={{...modalStyles.sectionTitle, color: '#166534'}}>DDR</h3>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Idn (mA)</label>
                <select value={data.idn} onChange={(e) => handleChange('idn', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="30">30 mA</option>
                  <option value="300">300 mA</option>
                  <option value="500">500 mA</option>
                  <option value="1000">1000 mA</option>
                </select>
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Tempo (ms)</label>
                <select value={data.tempo} onChange={(e) => handleChange('tempo', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="S">S</option>
                  <option value="60">60 ms</option>
                  <option value="100">100 ms</option>
                  <option value="120">120 ms</option>
                  <option value="150">150 ms</option>
                  <option value="200">200 ms</option>
                </select>
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Essai</label>
                <select value={data.essai} onChange={(e) => handleChange('essai', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="B">B (Bon)</option>
                  <option value="M">M (Mauvais)</option>
                  <option value="NV">NV (Non Vérifié)</option>
                  <option value="SO">SO (Sans Objet)</option>
                </select>
              </div>

              <div style={modalStyles.formGroup}>
                <label style={modalStyles.label}>Isol</label>
                <select value={data.isol} onChange={(e) => handleChange('isol', e.target.value)} style={modalStyles.input}>
                  <option value="">Sélectionner...</option>
                  <option value="B">B (Bon)</option>
                  <option value="M">M (Mauvais)</option>
                  <option value="<0,5">&lt;0,5 MΩ</option>
                  <option value=">0,5">&gt;0,5 MΩ</option>
                  <option value="Autre">Autre (saisie libre)</option>
                </select>
                {data.isol === 'Autre' && (
                  <input type="text" value={data.isol_autre} onChange={(e) => handleChange('isol_autre', e.target.value)} style={modalStyles.inputAutre} placeholder="Précisez la valeur..." />
                )}
              </div>
            </div>
          </div>
        </div>

        <div style={modalStyles.footer}>
          <button style={modalStyles.btnSecondary} onClick={onClose}>Annuler</button>
          <button style={{...modalStyles.btnPrimary, opacity: isValid ? 1 : 0.5}} onClick={handleSave} disabled={!isValid}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
}

export default DisjoncteurModalMobile;
